import {BASE_URL} from "../../config/network";

const validateEmailAPI = async ({email}) => {
    const URL = `${BASE_URL}/public/email/validate?${new URLSearchParams({email}).toString()}`
    const METHOD = "GET"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    return {
        is_valid: true
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS
    })

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
    }

    return await response.json()
}

export {validateEmailAPI}
